var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-custom card-stretch"},[_c('div',{staticClass:"card-header border-0 pt-5"}),_c('div',{staticClass:"card-body pt-2 pb-0"})])
}]

export { render, staticRenderFns }